/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConfig.defs.js'
export { main as default } from './getConfig.defs.js'
